<template>
  <v-app-bar
    id="app-details-header"
    height="64"
    absolute
  >
    <v-btn
        color="primary"
        class="text-none"
        text
        @click="toAppList"
    >
      <v-icon left>
        mdi-chevron-left
      </v-icon>
      List Application
    </v-btn>
    <span class="mx-4">
      Application ID: {{currentApp.id}}
    </span>
    <v-spacer/>
    <v-switch
        v-model="currentApp.status"
        true-value="active"
        false-value="inactive"
        inset
        :label="statusText"
        hide-details
        flat
        @click="updateStatus"
    ></v-switch>
  </v-app-bar>
</template>

<script>
import {sync} from "vuex-pathify";
import {mapActions} from "vuex";

export default {
  name: "AppDetailsHeader",
  computed: {
    currentApp: sync('application/currentApp'),
    statusText() {
      return this.currentApp.status === 'active' ? 'Active': 'Inactive'
    }
  },
  methods: {
    ...mapActions('application', ['updateWithConfirm', 'findOne']),
    updateStatus() {
      this.updateWithConfirm(this.currentApp)
    },
    toAppList() {
      this.currentApp = {};
      this.$router.push('/applications')
    }
  }
}
</script>

<style scoped lang="scss">
#app-details-header {
  z-index: 7 !important;
}

</style>
